import React, { useState } from 'react';
import { useAppContext, SET_WINDOWS } from '../context/AppContext';
// import '../css/body.css';
import '../css/button.css';
import singleWindow from '../images/ui_buttons/window-button-single.png';
import doubleWindow from '../images/ui_buttons/window-button-double.png';

const WindowChoice = ({ selectedWindow }) => {
	const { dispatch } = useAppContext();

	const handleWindowChoice = (windowId) => {
		console.log('WindowChoice received click on', windowId);
		dispatch({ type: SET_WINDOWS, payload: windowId });
	};

	return (
		<div className='window-choice-container'>
			<h3>Windows</h3>
			<div className='window-choice-top-container'>
				<button
					className={`window-button ${selectedWindow === 'windows_one' ? 'selected' : ''}`}
					onClick={() => handleWindowChoice('windows_one')}>
					<img src={singleWindow} alt='One Window' className='window-image' />
				</button>
				<button
					className={`window-button ${selectedWindow === 'windows_two' ? 'selected' : ''}`}
					onClick={() => handleWindowChoice('windows_two')}>
					<img src={doubleWindow} alt='Two Windows' className='window-image' />
				</button>
			</div>
			<div className='window-choice-bottom-container'>
				<button
					className={`window-none-button ${
						selectedWindow === 'windows_none' ? 'selected' : ''
					}`}
					onClick={() => handleWindowChoice('windows_none')}>
					No Windows
				</button>
			</div>
		</div>
	);
};

export default WindowChoice;
